<template>
    <div id="chartdiv" style="width: 100%; height: 500px"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import * as am4themes_animated from "@amcharts/amcharts4/themes/animated";

export default {
    props: ["data"],
    data() {
        return {
            chart: null,
        };
    },
    mounted() {
        am4core.useTheme(am4themes_animated.default);
        this.chart = am4core.create("chartdiv", am4charts.XYChart);

        // Create axes
        let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "maindealer";
        categoryAxis.renderer.grid.template.location = 0;

        let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.title.text = "Total Bongkar";
        valueAxis.extraMax = 0.1; // Add extra space at the top

        let percentageAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
        percentageAxis.renderer.opposite = true;
        percentageAxis.title.text = "Defect Percentage (%)";
        percentageAxis.renderer.grid.template.disabled = true;
        percentageAxis.syncWithAxis = valueAxis; // Synchronize zooming

        // Rotate the title of the percentage axis
        percentageAxis.title.rotation = 270;
        percentageAxis.title.align = "center"; // Align the title to the center
        percentageAxis.title.dy = -10; // Adjust position

        // Create column series for total angkut
        let columnSeries = this.chart.series.push(new am4charts.ColumnSeries());
        columnSeries.dataFields.valueY = "total_pengiriman";
        columnSeries.dataFields.categoryX = "maindealer";
        columnSeries.name = "Total Bongkar";
        columnSeries.columns.template.width = 70;
        columnSeries.columns.template.strokeWidth = 0;

        // Set column properties
        let columnTemplate = columnSeries.columns.template;
        columnTemplate.strokeWidth = 0;
        columnTemplate.strokeOpacity = 0;
        columnTemplate.column.cornerRadiusTopLeft = 5;
        columnTemplate.column.cornerRadiusTopRight = 5;

        // Add labels to the columns
        let labelBullet = columnSeries.bullets.push(
            new am4charts.LabelBullet()
        );
        labelBullet.label.html = `<span style="color: #BB3E3E; font-size: 14px;">&#x25A0;</span> {total_defect}`; // Red square character
        labelBullet.label.text = "{total_defect}";
        labelBullet.label.fill = am4core.color("#BB3E3E");
        labelBullet.label.dy = -10; // Adjust position of the label

        // Add a new label for total_angkut
        let labelBullet2 = columnSeries.bullets.push(
            new am4charts.LabelBullet()
        );
        labelBullet2.label.text = "{valueY}";
        labelBullet2.label.fill = am4core.color("#000000");
        labelBullet2.locationY = 0.5; // Position label in the middle of the bar

        // Conditionally set column color based on maindealer
        columnSeries.columns.template.adapter.add(
            "fill",
            function (fill, target) {
                if (target.dataItem.dataContext.maindealer === "M3Z") {
                    return am4core.color("#FF83A2");
                }
                return am4core.color("#83A2FF");
            }
        );

        // Create line series for defect percentage
        let lineSeries = this.chart.series.push(new am4charts.LineSeries());
        lineSeries.dataFields.valueY = "calculated_percent_rusak";
        lineSeries.dataFields.categoryX = "maindealer";
        lineSeries.yAxis = percentageAxis;
        lineSeries.name = "Defect Percentage";
        lineSeries.stroke = am4core.color("#84EB71"); // Line color
        lineSeries.strokeWidth = 2;
        lineSeries.tooltipText = "{name}: [bold]{valueY}[/]";
        lineSeries.tooltip.getFillFromObject = false; // IMPORTANT for customizing tooltip style
        lineSeries.tooltip.background.fill = am4core.color("#84EB71"); // tooltip background color
        lineSeries.tooltip.label.fill = am4core.color("#125E1E"); // tooltip font color

        // Add square bullets to the line series
        const bullet = lineSeries.bullets.push(new am4charts.Bullet());
        const square = bullet.createChild(am4core.Rectangle);
        square.width = 10;
        square.height = 10;
        square.horizontalCenter = "middle";
        square.verticalCenter = "middle";
        square.fill = am4core.color("#84EB71"); // Change bullet color

        // Add legend for column series
        this.chart.legend = new am4charts.Legend();
        this.chart.legend.position = "top";
        this.chart.legend.contentAlign = "right";
        this.chart.legend.valign = "right";
        this.chart.legend.marginBottom = 10; // Add some bottom spacing to the legend

        // Add items to the legend
        let legendData = [
            {
                name: "Total Bongkar",
                fill: "#000000",
                bullet: "<span style='font-size:14px;color:#000000;'>&#x25A0;</span>",
            },
            {
                name: "Defect Unit",
                fill: "#BB3E3E",
                bullet: "<span style='font-size:14px;color:#BB3E3E;'>&#x25A0;</span>",
            },
        ];
        this.chart.legend.data = legendData;
        this.chart.legend.useDefaultMarker = true;

        // Customize the legend items to include the bullet
        this.chart.legend.markers.template.width = 18;
        this.chart.legend.markers.template.height = 18;
        let marker = this.chart.legend.markers.template.children.getIndex(0);
        marker.cornerRadius(0, 0, 0, 0);
        marker.strokeWidth = 0;

        // Add chart cursor
        this.chart.cursor = new am4charts.XYCursor();

        // Add separate legend for line series
        let lineLegend = new am4charts.Legend();
        lineLegend.parent = this.chart.chartContainer;
        lineLegend.data = [
            {
                name: "Defect Percentage",
                fill: "#84EB71",
                bullet: "<span style='font-size:14px;color:#84EB71;'>&#x25A0;</span>",
            },
        ];
        lineLegend.position = "bottom";
        lineLegend.contentAlign = "center";
        // lineLegend.marginTop = 20; // Add some top spacing to the legend

        // Fetch initial data
        this.fetchData();
    },
    watch: {
        data: {
            deep: true,
            handler: "fetchData",
        },
    },
    methods: {
        fetchData() {
            console.log('data', this.data);
            const processedData = this.data.map((item) => {
                return {
                    ...item,
                    total_pengiriman: Number(item.total_defect) + Number(item.total_angkut),
                    calculated_percent_rusak:
                        ((item.total_defect / item.total_angkut) * 100).toFixed(2),
                };
            });

            // Set chart data
            this.chart.data = processedData;
        },
    },
};
</script>

<style scoped>
/* Any custom styles you want to add */
</style>
